import { render, staticRenderFns } from "./IOSSNumbersTableUser.vue?vue&type=template&id=7bcb1f2a&scoped=true"
import script from "./IOSSNumbersTableUser.vue?vue&type=script&lang=js"
export * from "./IOSSNumbersTableUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcb1f2a",
  null
  
)

export default component.exports